import React, {useContext, useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Button, Card, Col, Dropdown, Form, Layout, MenuProps, Row, Select, Space, Typography} from "antd";
import ReactMarkdown from "react-markdown";
import {AuthContext} from "../../../config/AuthContext";
import AppSider from "../AppSider";
import {Aula, defaultAula} from "../../../model/Aula";
import {Torn} from "../../../model/Torn";
import {DefaultTemps} from "../../../model/Temps";
import {DeleteDuda} from "../../../dao/DeleteDuda";
import {PostDuda} from "../../../dao/PostDuda";
import {GetAules} from "../../../dao/GetAules";
import {DownOutlined} from '@ant-design/icons';
import Alert from "antd/es/alert/Alert";
import HomeColors from "../../../styles/HomeColors";
import TextArea from "antd/es/input/TextArea";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import {FaArrowCircleDown} from "react-icons/fa";
import {GiInnerSelf} from "react-icons/gi";
import {SiWebmoney} from "react-icons/si";
import {GetTornDubte} from "../../../dao/GetTornDubte";

const {Title, Text} = Typography;
const {Content} = Layout;
const {Option} = Select;

const Dubtes = () => {
    let refreshInterval: any;
    const {isLoggedIn, userId, setBreadCrumb, alumne} = useContext(AuthContext);
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const [aules, setAules] = useState<Aula[] | null>([defaultAula]);
    const [aulaSel, setSelAula] = useState<string | null>(null);
    const [aula, setAula] = useState<any>({});
    const [isButtonHidden, setIsButtonHidden] = useState(true);
    const [torn, setTorn] = useState<Torn>({torn: -1, cua: false, chatgpt: '', dubte: '', atencio: false});
    const [isDisabled, setIsDisabled] = useState(true);
    const [showTemps, setShowTemps] = useState(false);
    const [temps, setTemps] = useState(DefaultTemps);
    const [loading, setLoading] = useState(false);
    const [pantalla, setPantalla] = useState(1);

    const [enviado, setEnviado] = useState(false);

    async function handleAulaChange(value: string) {

        const aulesArray = await GetAules(userId);
        window.clearInterval(refreshInterval);
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () {
        }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }
        refreshInterval = null;

        const tornR = await GetTornDubte(value, userId);
        setTorn(tornR);
        setEnviado(tornR.cua);
        setSelAula(value);

        if (aulesArray) {
            //console.log("VALUE Undefined:" + value);
            console.log(aulesArray);

            if (Array.isArray(aulesArray)) {
                const selectedAula = aulesArray.find((aula: any) => aula.id == value);
                setAula(selectedAula || {});
            } else {
                setAula(aulesArray);
            }

        } else {
            //console.log("VALUE:" + value);
            //console.log(aules);
            const selectedAula = aules?.find((aula: any) => aula.id == value);
            //console.log(selectedAula);
            setAula(selectedAula || {});
        }


        if (!value) {
            setIsButtonHidden(true);
            setShowTemps(false);
            setTorn({torn: -1, cua: false, chatgpt: '', dubte: '', atencio: false});
        } else {
            setIsButtonHidden(false);
            setShowTemps(true);
            //const tmp = await GetTempsInvertit(value, userId);
            //setTemps(tmp);

            refreshInterval = setInterval(async () => {
                const updatedTornR = await GetTornDubte(value, userId);
                setTorn(updatedTornR);
                if (!updatedTornR.cua)
                    setEnviado(false);
            }, 3000);
        }
    }

    const items: MenuProps['items'] = [
        {
            label: 'Sol·lucionat amb company/a',
            key: '1',
            icon: <GiInnerSelf/>,
        },
        {
            label: 'Sol·lucionat buscant apunts o internet',
            key: '2',
            icon: <SiWebmoney/>,
        },
        {
            label: 'Sol·lucionat per explicació general professor/a',
            key: '3',
            icon: <SiWebmoney/>,
        }
    ];

    // Guardar bé timestamps (quan surto de cua si ha vingut el profe o no i al experimental tam´be si surto de cua

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        //console.log((-1-parseInt(e.key)));
        salirCola((-1 - parseInt(e.key)));
    };

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    const checkAules = async () => {
        const aules = await GetAules(userId);
        setAules(aules);
        //console.log(aules);
        if (aules.length === 1)
            await handleAulaChange(aules[0].id);
    };

    useEffect(() => {
        checkAules();
        setBreadCrumb([{nom: 'Home', nav: '/home'},
            {nom: 'dubtes', nav: '/dubtes'}], true);

        return () => {

            if (refreshInterval && refreshInterval.current) {
                clearInterval(refreshInterval.current);
                refreshInterval.current = null;
            }

            window.clearInterval(refreshInterval);
            // Get a reference to the last interval + 1
            const interval_id = window.setInterval(function () {
            }, Number.MAX_SAFE_INTEGER);

            // Clear any timeout/interval up to that id
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }
            refreshInterval = null;
        };
    }, [enviado, loading]);


    async function salirCola(estat: number) {
        if (estat !== 0)
            setIsDisabled(true);
        //console.log("Salir de cola");
        const tor = await DeleteDuda(aulaSel ?? "-1", userId, estat);
        setTorn(tor);
        //console.log("NOU TORN: " + JSON.stringify(tor));
        setLoading(false);
        setEnviado(false);
    }

    function setPnt(value: number) {
        setPantalla(value);
    }

    async function submitData() {
        setLoading(true);
        setEnviado(true);

        window.clearInterval(refreshInterval);
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () {
        }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }
        refreshInterval = null;

        const formData = form.getFieldsValue();
        const torn = await PostDuda(aulaSel ?? "-1", userId, formData.pregunta,0,0,0);
        //console.log("NOVA DATA POSADA: " + JSON.stringify(torn));
        setTorn(torn);

        window.clearInterval(refreshInterval);
        refreshInterval = setInterval(async () => {
            const updatedTornR = await GetTornDubte(aulaSel ?? "-1", userId);
            setTorn(updatedTornR);
            if (!updatedTornR.cua)
                setEnviado(false);
            //console.log(updatedTornR);
        }, 3000);
    }

    if (isLoggedIn) {
        return (
            <>
                <AppSider currentVal={1} setPantalla={setPnt}/>
                <Content style={{padding: '0 24px', minHeight: 280}}>
                    <Row style={{marginBottom: 20}}>
                        <Col span={24}>
                            <Select disabled={!aules || aules.length <= 1}
                                    style={{width: '100%'}}
                                    value={aulaSel}
                                    onChange={handleAulaChange}
                                    placeholder="Escollir aula"
                            >
                                {aules?.map((alumne: any) => (
                                    <Select.Option key={alumne.id} value={alumne.id}>
                                        {alumne.nom} {alumne.cognoms}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                    {(aulaSel === undefined || aulaSel === null) ? <Alert
                            message={aules && aules?.length > 0 ? "Escollir aula primer de tot" : "No tens aules asignades..."}
                            type={"info"}/>
                        :
                        (
                            <section style={{backgroundColor: '#eee'}}>
                                <Card>
                                    {torn.cua && torn.chatgpt ?
                                        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                            <img src={"/images/aiavatar1.png"}
                                                 alt="avatar"
                                                 className="rounded-circle img-fluid"
                                                 style={{width: '50px'}}
                                            />
                                            <h3>{alumne.alumne.nom} ja tens resposta de la IA! <FaArrowCircleDown/></h3>
                                        </div>
                                        :

                                        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                            <img src={alumne.alumne.avatar}
                                                 alt="avatar"
                                                 className="rounded-circle img-fluid"
                                                 style={{width: '50px'}}
                                            />
                                            <h3>HOLA {alumne.alumne.nom}!</h3>
                                        </div>
                                    }
                                    <hr/>

                                    {!torn.cua && torn.torn > 0 && aula?.tipus !== 1 &&
                                        <Alert message={`Hi ha ${torn.torn} persones en cua...`} type={"warning"}/>}
                                    {!enviado && !torn.cua && torn.torn === 0 && aula?.tipus !== 1 &&
                                        <Alert message={`Ets el/la següent!!`} type={"info"}/>}
                                    <br/>
                                    <Form form={form} initialValues={torn} onFinish={submitData}>
                                        {!torn.cua && aula?.tipus === 0 &&
                                            <>
                                                <Row gutter={[16, 16]}>
                                                    <Col span={24}>
                                                        <Text>Explica el teu dubte amb detall:</Text>
                                                        <Form.Item name="pregunta"
                                                                   rules={[{
                                                                       required: true,
                                                                       message: 'camp obligatori!!'
                                                                   }]}>
                                                            <TextArea
                                                                onKeyUp={(e) => setIsDisabled(e.currentTarget.value.length < 20)}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <hr/>
                                            </>
                                        }

                                        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                            <Form.Item>
                                                <Button style={{backgroundColor: HomeColors.colors.color4}}
                                                        htmlType="submit"
                                                        loading={enviado && torn?.cua}
                                                        disabled={isDisabled && aula?.tipus === 0}>
                                                    {!enviado ? "Demanar ajuda" :
                                                        (aula?.tipus === 1 ? "En cua..." :
                                                            (torn.torn > 0 ? `Hi ha ${torn.torn} persones en cua...`
                                                                : `Ets el/la següent!`))}
                                                </Button>
                                            </Form.Item>
                                            {aula?.tipus === 0 && <Form.Item>
                                                <Button htmlType="button"
                                                        style={{backgroundColor: HomeColors.colors.color4}}
                                                        hidden={torn?.chatgpt === '' ||
                                                            torn?.chatgpt === null && !torn?.cua}
                                                        loading={(torn?.chatgpt === '' ||
                                                            torn?.chatgpt === null) && torn?.cua}
                                                        onClick={() => salirCola(1)}>
                                                    {(torn?.chatgpt === '' ||
                                                        torn?.chatgpt === null) && torn?.cua ? "Esperant resposta de la IA..."
                                                        : "La IA ha resolt el meu dubte!"}
                                                </Button>
                                            </Form.Item>
                                            }

                                            {aula?.tipus === 2 ?
                                                <Form.Item>
                                                    <Dropdown menu={menuProps}>
                                                        <Button htmlType="button"
                                                                style={{backgroundColor: HomeColors.colors.color6}}
                                                                hidden={!torn.cua}
                                                            //onClick={() => salirCola(-1)}
                                                        >
                                                            <Space>
                                                                Sortir de la cua
                                                                <DownOutlined/>
                                                            </Space>
                                                        </Button>
                                                    </Dropdown>
                                                </Form.Item>
                                                :
                                                <>
                                                    {aula?.tipus === 1 && !torn?.atencio &&
                                                        <Form.Item>
                                                            <Button htmlType="button"
                                                                    style={{backgroundColor: HomeColors.colors.color5}}
                                                                    hidden={!torn.cua} onClick={() => salirCola(0)}>
                                                                Arribada del professor/a
                                                            </Button>
                                                        </Form.Item>
                                                    }
                                                    <Form.Item>
                                                        <Button htmlType="button"
                                                                style={{backgroundColor: HomeColors.colors.color6}}
                                                                hidden={!torn.cua} onClick={() => salirCola(-1)}>
                                                            Sortir de la cua
                                                        </Button>
                                                    </Form.Item>
                                                </>
                                            }


                                        </div>
                                    </Form>

                                    {torn.chatgpt !== "" && torn.chatgpt !== null && aula?.tipus === 0 &&
                                        <>
                                            <Card>
                                                <Card.Meta
                                                    avatar={<img src={alumne.alumne.avatar}
                                                                 alt="avatar"
                                                                 className="rounded-circle img-fluid"
                                                                 style={{width: '70px'}}
                                                    />}
                                                    title={`${alumne.alumne.nom} ${alumne.alumne.cognoms}`}
                                                    description={
                                                        <>
                                                            <ReactMarkdown
                                                                remarkPlugins={[remarkGfm]}
                                                                rehypePlugins={[rehypeRaw]}
                                                            >{torn.dubte}
                                                            </ReactMarkdown>
                                                        </>
                                                    }
                                                />
                                            </Card>
                                            <Card>
                                                <Card.Meta
                                                    avatar={<img src={"/images/aiavatar1.png"}
                                                                 alt="avatar"
                                                                 className="rounded-circle img-fluid"
                                                                 style={{width: '70px'}}
                                                    />}
                                                    title="Resposta de la IA"
                                                    description={
                                                        <>
                                                            <ReactMarkdown
                                                                remarkPlugins={[remarkGfm]}
                                                                rehypePlugins={[rehypeRaw]}
                                                            >{torn.chatgpt}
                                                            </ReactMarkdown>
                                                        </>
                                                    }
                                                />
                                            </Card>
                                        </>
                                    }
                                </Card>
                            </section>
                        )}
                </Content>
            </>
        );
    } else {
        navigate("/login");
        return null;
    }
};

export default Dubtes;
